var exports = {
  "az": "Box__hYA5AR",
};

module.exports = exports;
